import React, { useState } from "react";
import { TextField, Tooltip } from "@mui/material";
import { set } from "lodash";
import { errorJsonHasErrors } from "./Input_Fns";


export const InputMoney = ({
  money,
  label,
  xlabel,
  name = "Value",
  required = false,
  negative = false,
  min = 0,
  max = 10000000,
  onChange,
  tooltip = "",
  errors_ = null,
  onError = null,
  width = 120,
  ...others
}) => {
  const [errors, setErrors] = useState({})

  const onBlur = (e) => {
    let ne = structuredClone(errors)
    let err = ""
    const m = Number(money)
    if (e.target.name === name) {
      if (e.target.value.includes(".")) {
        err = "Please enter an integer value"
      } else if (negative) {
        if (m < -max || m > -min) {
          //err = "Please enter between " + (-min) + " and " + (-max)
          err = "" + (-min) + " to " + (-max)

        }
      } else {
        if (m < min || m > max) {
          err = "Please enter between " + min + " and " + max
          err = "" + min + " to " + max

        }
      }
      if (errors_ !== null && err === "" && errors_[name] !== "") {
        err = errors_[name]
      }
      ne = set(ne, e.target.name, err)
      setErrors(ne)
      if (onError !== null) {
        onError(errorJsonHasErrors(ne) ? "Errors" : "")
      }
      //console.log(ne)
    }
  }

  const getMin = () => {
    if (negative) {
      return -max;
    }
    return min;
  };
  const getMax = () => {
    if (negative) {
      return -min;
    }
    return max;
  };

  const onChange_v = (e) => {
    //const regex = /^[0-9\b]+$/;
    // const regex = /^[-+]?[0-9]+$/;
    // if (e.target.value === "" ||
    //   e.target.value === "-" ||
    //   e.target.value === "+") {
    //   onChange(e)
    // } else if (regex.test(e.target.value)) {
    //   onChange(e)
    // } else {
    //   e.target.value = String(parseInt(e.target.value))
    //   onChange(e)
    // }
    // need to avoid decimals
    // const regex = /^[-+]?[0-9]+$/;
    // if (regex.test(e.target.value)) {
    //   onChange(e)
    // }
    onChange(e)
  }


  return (
    <Tooltip title={tooltip} arrow>
      <TextField
        label={xlabel ? xlabel : label ? label + " Value" : "Value"}
        name={name}
        type="number"
        slotProps={{
          htmlInput: {
            min: getMin(),
            max: getMax(),
            step: 1,
          },
        }}
        required={required}
        onWheel={(e) => e.target instanceof HTMLElement && e.target.blur()}
        sx={{ width: width }}
        size="small"
        value={money}
        onChange={onChange_v}
        error={!!errors[name]}
        helperText={errors[name]}
        onBlur={onBlur}
        {...others}
      />
    </Tooltip>
  );
};
